import { ExpandIcon } from '../PRIVATE_ThemedIcons/ExpandIcon';
import { CollapseIcon } from '../PRIVATE_ThemedIcons/CollapseIcon';
import { CollapseUpIcon } from '../PRIVATE_ThemedIcons/CollapseUpIcon';

type IconProps = {
  isExpanded: boolean;
  isDisabled?: boolean;
  iconPosition?: 'start' | 'end';
};

/**
 * Header icon subcomponent
 */
export const CollapsibleHeaderIcon = ({ isExpanded, isDisabled, iconPosition }: IconProps) => {
  const color = isDisabled ? 'disabled' : 'primary';
  const startIcon = iconPosition === 'start' && isExpanded ? ExpandIcon : CollapseIcon;
  const endIcon = iconPosition === 'end' && isExpanded ? CollapseUpIcon : ExpandIcon;
  const Icon = iconPosition === 'start' ? startIcon : endIcon;

  return <Icon size="6x" color={color} />;
};
